import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import { Card, Row } from "antd";
import Heading from "../../../component/common/Heading";
import useHttp from "../../../hooks/use-http";
import ModalFormCreator from "../../../component/common/ModalFormCreator";
import CRUDComponent from "../../../component/common/CRUD-Component";
import { role } from "../../../util/Route";

const Users = () => {
  const navigate = useNavigate();
  const api = useHttp()
  const [notificationSent, setNotificationSent] = useState(null)


  const notificationHandler = (value, clear) => {
    value = {
      ...value,
      petId: null,
      userId: notificationSent,
    }

    // console.log(value);

    const NOTIFICATION_API = { ...CONSTANTS.API.User.notification }

    api.sendRequest(NOTIFICATION_API, () => {
      setNotificationSent(null)
      clear()
    }, value, 'Notification Sent Successfully!!!')
  }


  return (
    <>

      <div>
        <Card className="my-5">
          <Heading>User List</Heading>
          <Row>
            <CRUDComponent

              GET={{
                API: CONSTANTS.API.User.getAll,
                DataModifier: (res, API, Setrefresh) => {
                  // console.log(res, "GET ALL ABCD");
                  return res?.map(data => {
                    return {
                      ...data,
                      no: `U${data?.id.toString().padStart(7, "0")}`,
                      mobile: data?.mobile ? `+${data?.countryCode || ''} ${data?.mobile} ` : '-',
                      email: data?.email || '-',
                      isBlocked: {
                        checked: !data?.isBlock,
                        id: data?.id,
                        onClick: (id, val) => {
                          const UpdateAPIEnd = { ...CONSTANTS?.API.User.update };
                          UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                          console.log(UpdateAPIEnd);
                          API.sendRequest(
                            UpdateAPIEnd,
                            () => {
                              Setrefresh((prev) => !prev);
                            },
                            { isBlock: val },
                            `User ${val ? "Blocked" : "Unblocked"} Successfully`
                          );
                        },
                        // onClick: () => { }
                      },
                      view: {
                        id: data?.id,
                        onClick: () => {
                          navigate(`/app/users/${data?.id}`)
                        }
                      },
                      notification: {
                        id: data?.id,
                        onClick: () => {
                          setNotificationSent(data?.id)
                        }
                      }
                    }
                  })
                },
                column: role === 'Admin' ? CONSTANTS.TABLE.USERS : CONSTANTS.TABLE.USERS.filter(ele => ele.dataIndex !== 'notification'),
              }}
              isSearch={true}






            />
          </Row>
        </Card>
      </div>
      <ModalFormCreator
        loading={api.isLoading}
        open={notificationSent !== null}
        onCreate={notificationHandler}
        onCancel={() => {
          setNotificationSent(null);
        }}
        menuFields={CONSTANTS.FORM_FIELD.NOTIFICATION_MODAL}
        name={'Personal Notification'}
        SubmitName={"Submit"}
      />
    </>
  );
};

export default Users;
